import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import './api/mock'
import Cookies from 'js-cookie'
import './style/index.css'
import querystring from "query-string"
Vue.use(ElementUI)

Vue.prototype.$querystring = querystring
Vue.config.productionTip = false

Vue.prototype.$validateIdCard = (id) => {
  if (!/(^\d{15}$)|(^\d{17}[\dXx]$)/.test(id)) return false;
  if (id.length === 15) {
    id = id.substring(0,6) + '19' + id.substring(6);
    id += calculateCheckCode(id);
  }
  if (id.length === 18 && !validateCheckCode(id)) return false;
  if (!validateBirthday(id)) return false;
  const areaCode = id.substr(0,2);
  const validAreas = ['11','12','13','14','15','21','22','23','31','32','33',
                      '34','35','36','37','41','42','43','44','45','46','50',
                      '51','52','53','54','61','62','63','64','65','71','81','82'];
  return validAreas.includes(areaCode);
}

// 路由守卫
router.beforeEach((to, from, next) => {
    var phoneKey=Cookies.get('phoneKey');
    var userinfo=Cookies.get('userinfo');
    if(!phoneKey||!userinfo) {
        if(to.path!="/home" && to.path!="/login" && to.path!="/forgetpwd" && to.path != '/pageindex'){
            next({ path: '/login' })
            return false;
        }
    }
	next()
})



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')